type Lang = "en" | "de" | "fr";

const SUCCESS: Record<Lang, string> = {
  en: "✓ Thanks",
  de: "✓ Danke",
  fr: "✓ Merci",
};

const ERROR: Record<Lang, string> = {
  en: "Try again",
  de: "Erneut versuchen",
  fr: "Réessayer",
};

function pageLang(): Lang {
  const l = document.documentElement.lang;
  return l === "de" || l === "fr" ? l : "en";
}

async function handleSubscribe(e: SubmitEvent): Promise<void> {
  e.preventDefault();
  const form = e.target as HTMLFormElement;
  const emailInput = form.elements.namedItem("email") as HTMLInputElement | null;
  const nameInput = form.elements.namedItem("firstName") as HTMLInputElement | null;
  const btn = form.querySelector<HTMLButtonElement>("button");
  if (!emailInput || !btn) return;

  const email = emailInput.value.trim();
  if (!email) return;
  const firstName = nameInput?.value.trim() ?? "";

  const lang = pageLang();
  const original = btn.innerHTML;
  btn.disabled = true;
  emailInput.disabled = true;
  if (nameInput) nameInput.disabled = true;

  try {
    const resp = await fetch("/api/newsletter", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ email, firstName, language: lang }),
    });

    if (!resp.ok) throw new Error(`status ${resp.status}`);

    btn.innerHTML = SUCCESS[lang];
    btn.style.background = "var(--bg)";
    btn.style.color = "var(--ink)";
    emailInput.value = "";
    if (nameInput) nameInput.value = "";
  } catch {
    btn.innerHTML = ERROR[lang];
  } finally {
    setTimeout(() => {
      btn.innerHTML = original;
      btn.style.background = "";
      btn.style.color = "";
      btn.disabled = false;
      emailInput.disabled = false;
      if (nameInput) nameInput.disabled = false;
    }, 2400);
  }
}

export function initNewsletter(): void {
  document
    .querySelectorAll<HTMLFormElement>(".news-form")
    .forEach((form) => form.addEventListener("submit", handleSubscribe));
}
